/* @flow */

export default {
  root: {
    width: 43,
    height: 31,
  },
};
